import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaMapMarkerAlt, 
  FaDirections, 
  FaGlobe, 
  FaMapPin, 
  FaHome 
} from 'react-icons/fa';
import './Sitemap.css';

const GoogleMapComponent = () => {
  // Try these coordinates (more specific to Kayonza area)
  const mapCoordinates = {
    lat: -1.9200,
    lng: 30.4350,
    placeName: "URUGO ECO-LODGE AT THE WOMEN'S OPPORTUNITY CENTER",
    address: "3FHW+W33, Kayonza, Rwanda"
  };

  // SIMPLE and RELIABLE embed URL
  const basicMapsUrl = `https://www.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}&hl=en&z=15&output=embed`;
  
  // Alternative: Search by place name (might work better)
  const placeSearchUrl = `https://www.google.com/maps/embed/v1/place?q=URUGO+ECO+LODGE+Kayonza+Rwanda&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&zoom=15`;
  
  // Use a marker with coordinates
  const markerUrl = `https://maps.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}&z=15&output=embed`;
  
  // Better: Use Google Maps with marker parameter
  const mapsWithMarker = `https://www.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}&ll=${mapCoordinates.lat},${mapCoordinates.lng}&z=15&output=embed`;

  // Best: Simple coordinates embed
  const simpleEmbed = `https://maps.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}&z=15&t=m&output=embed`;

  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${mapCoordinates.lat},${mapCoordinates.lng}`;
  
  const directMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapCoordinates.placeName + ', Kayonza, Rwanda')}`;

  return (
    <div className="google-map-section">
      <div className="map-container">
        {/* Back to Home Button - Top Right */}
        <div className="back-home-container">
          <Link to="/" className="back-home-btn">
            <FaHome /> Back to Home
          </Link>
        </div>

        <div className="map-header">
          <h2><FaMapMarkerAlt /> Our Location</h2>
          <p>Find us at the URUGO Women's Opportunity Center</p>
        </div>

        <div className="map-wrapper">
          {/* Try different URLs - use the one that works */}
          <iframe
            title="URUGO Women's Opportunity Center Location"
            src={simpleEmbed}
            width="100%"
            height="400"
            className="google-map-iframe"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0 }}
          />
          <div className="map-note">
            <FaMapPin /> Map showing URUGO ECO-LODGE location in Kayonza
          </div>
        </div>

        <div className="map-details">
          <div className="location-info">
            <div className="info-item">
              <FaGlobe className="info-icon" />
              <div>
                <h3>{mapCoordinates.placeName}</h3>
                <p className="address">{mapCoordinates.address}</p>
                <p className="region">Kayonza District, Eastern Province, Rwanda</p>
              </div>
            </div>
            
            <div className="info-item coordinates-item">
              <div>
                <h4><FaMapMarkerAlt /> Exact Coordinates</h4>
                <p className="coordinates">
                  <strong>Latitude:</strong> {mapCoordinates.lat.toFixed(6)}° S<br />
                  <strong>Longitude:</strong> {mapCoordinates.lng.toFixed(6)}° E
                </p>
                <p className="map-test-link">
                  <a 
                    href={`https://www.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Test these coordinates on Google Maps →
                  </a>
                </p>
              </div>
            </div>

            <div className="map-actions">
              <a
                href={directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="direction-btn"
              >
                <FaDirections /> Get Directions
              </a>
              <a
                href={`https://www.google.com/maps?q=${mapCoordinates.lat},${mapCoordinates.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                className="view-map-btn"
              >
                Open Coordinates in Maps
              </a>
            </div>

            <div className="location-tips">
              <h4>If map doesn't show correct location:</h4>
              <ul>
                <li>Click "Open Coordinates in Maps" button above</li>
                <li>Search manually: "URUGO ECO-LODGE Kayonza"</li>
                <li>Use Google Plus Code: <code>3FHW+W33 Kayonza</code></li>
                <li>Coordinates: {mapCoordinates.lat.toFixed(6)}, {mapCoordinates.lng.toFixed(6)}</li>
              </ul>
            </div>

            {/* Back to Home Button - Bottom Center */}
            <div className="back-home-bottom">
              <Link to="/" className="back-home-btn large">
                <FaHome /> Return to Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleMapComponent;